// Interfaces
import { IAuthAuthenticatedUser } from 'interfaces/auth'
import { IRoleListRef } from 'interfaces/back-office/master/role'
import { IUserAccess } from 'interfaces/back-office/user-access'

// Utils
import { commonUtils_removeDuplicateFlatten } from 'utils/common/common.utils'

// Lodash
import flattenDeep from 'lodash/flattenDeep'

/**
 * @description Get user access code from authenticated user
 *
 * @param {IAuthAuthenticatedUser} authenticatedUser
 *
 * @return {number[]} number[]
 */
export const authUtils_getUserUserAccessCodes = (authenticatedUser: IAuthAuthenticatedUser): number[] => {
  const filterRoutesAccessCode = flattenDeep(
    authenticatedUser?.roles
      ?.filter((role: IRoleListRef) => role.status)
      .map((role: IRoleListRef) => role.access.map((access: IUserAccess) => access.code)),
  ) as number[]

  // Remove the duplicate access code
  const remapAccessCode = commonUtils_removeDuplicateFlatten(filterRoutesAccessCode)

  // If user not validated and corcomm, return the profile and my document / document proofs access code (222, 223, 224)
  if (authenticatedUser.fieldId === 2) {
    return !authenticatedUser?.isValidated ? [222, 223, 224, 225] : remapAccessCode  
  }
  // If user not validated and not corcomm, just return the profile access code (222, 224)
  return !authenticatedUser?.isValidated ? [222, 224] : remapAccessCode
}
